import { availableModes } from "@/components/creator/sing/SingOptions";

function Range({ id, label, value, min, max, step, unit, onChange, left, right, disabled }) {
  const shown = unit === "ms" ? `${value > 0 ? "+" : ""}${value} ms` : `${value > 0 ? "+" : ""}${value.toFixed(1)} dB`;
  return (
    <label className="block">
      <span className="mb-1.5 flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.16em] text-white/55">
        {label}
        <span className="flex items-center gap-2">
          <span data-testid={`${id}-value`} className="text-white/80">{shown}</span>
          {value !== 0 ? <button type="button" data-testid={`${id}-reset`} onClick={() => onChange(0)} disabled={disabled} className="text-white/40 hover:text-white">Reset</button> : null}
        </span>
      </span>
      <input type="range" data-testid={id} min={min} max={max} step={step} value={value} disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))} className="w-full accent-amber-300 disabled:opacity-40" />
      {left ? <span className="mt-0.5 flex justify-between text-[10px] text-white/35"><span>{left}</span><span>{right}</span></span> : null}
    </label>
  );
}

/** What stays under your voice, when your voice comes in, and how loud each side is. */
export default function MixControls({ backing, settings, onChange, disabled }) {
  const modes = availableModes(backing);
  return (
    <div className="space-y-6">
      <div>
        <p className="mb-2 font-mono text-[10px] uppercase tracking-[0.18em] text-white/55">Keep from the original</p>
        <div role="radiogroup" className="grid gap-2 sm:grid-cols-3">
          {modes.map((m) => (
            <button key={m.key} type="button" role="radio" aria-checked={settings.backing_mode === m.key} data-testid={`replace-mode-${m.key}`} disabled={disabled}
              onClick={() => onChange({ backing_mode: m.key })}
              className={`rounded-2xl border px-3.5 py-3 text-left transition-colors duration-200 disabled:opacity-50 ${settings.backing_mode === m.key ? "border-amber-300/60 bg-amber-500/15 text-white" : "border-white/10 bg-white/[0.03] text-white/70 hover:bg-white/[0.07]"}`}>
              <p className="font-display text-[13px] font-semibold">{m.label}</p>
              <p className="mt-0.5 text-[11px] leading-snug text-white/50">{m.hint}</p>
            </button>
          ))}
        </div>
      </div>
      <div className="grid gap-6 md:grid-cols-3">
        <Range id="replace-shift" label="Timing" unit="ms" value={settings.shift_ms} min={-300} max={300} step={10} left="Earlier" right="Later"
          onChange={(v) => onChange({ shift_ms: v })} disabled={disabled} />
        <Range id="replace-vocal-level" label="Your voice" unit="dB" value={settings.vocal_db} min={-12} max={6} step={0.5} left="Softer" right="Louder"
          onChange={(v) => onChange({ vocal_db: v })} disabled={disabled} />
        <Range id="replace-music-level" label="Music" unit="dB" value={settings.music_db} min={-12} max={3} step={0.5} left="Softer" right="Louder"
          onChange={(v) => onChange({ music_db: v })} disabled={disabled} />
      </div>
    </div>
  );
}
